import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export function useBankAccountSelectionResult() {
  const { search } = useLocation();

  const { id, errorCode, errorMessage } = useMemo(() => {
    const params = new URLSearchParams(search);
    return {
      id: params.get('account_verification_report_id'),
      errorCode: params.get('error'),
      errorMessage: params.get('error_display_message'),
    };
  }, [search]);

  return { id, errorCode, errorMessage };
}
